/**
 * WooCommerce Product Bundles – Bundle-Sells handler.
 *
 * Bundle-sells are cross-sell add-ons shown on non-bundle product pages.
 * They use .bundle_data on the form but the form does NOT have .bundle_form class.
 * After the main product is added, selected bundle-sell items are added individually.
 */
export default {
	matches(form) {
		// Bundle-sells: .bundle_data present but NOT an actual bundle product
		return form.querySelector('.bundle_data') && !form.classList.contains('bundle_form');
	},

	buildApiData() {
		// Bundle-sells don't modify the main add-to-cart payload
		return null;
	},

	async afterAddToCart(form, formData, cartData, { refreshCartFromServer, refreshRecommendationsFromServer, state, storeApiUrl, headers }) {
		const bundleDataEl = form.querySelector('.bundle_data');
		const bundleFormData = JSON.parse(bundleDataEl.getAttribute('data-bundle_form_data') || '{}');
		const bsProductIds = bundleFormData.product_ids || {};
		let bundleSellsAdded = false;

		// Collect bundle-sell items: quantities and optional selection state
		const bsItems = {};
		for (const [key, value] of formData.entries()) {
			let m;
			if ((m = key.match(/^bundle_quantity_(\d+)$/))) {
				const id = m[1];
				if (!bsItems[id]) bsItems[id] = {};
				bsItems[id].quantity = parseInt(value) || 0;
			} else if ((m = key.match(/^bundle_selected_optional_(\d+)$/))) {
				const id = m[1];
				if (!bsItems[id]) bsItems[id] = {};
				bsItems[id].selected = true;
			}
		}

		// Add only items the user actually selected
		for (const [bundledItemId, item] of Object.entries(bsItems)) {
			if (item.selected !== true || !item.quantity || item.quantity <= 0) continue;

			const bsProductId = bsProductIds[bundledItemId];
			if (!bsProductId) continue;

			await fetch(storeApiUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: headers,
				body: JSON.stringify({ id: parseInt(bsProductId), quantity: item.quantity })
			});
			bundleSellsAdded = true;
		}

		// Refresh cart to reflect all added bundle-sell items
		if (bundleSellsAdded) {
			await refreshCartFromServer();
			refreshRecommendationsFromServer(state);
		}
	}
};
